import { render, staticRenderFns } from "./RequirementSelect.vue?vue&type=template&id=5b09b538"
import script from "./RequirementSelect.vue?vue&type=script&lang=js"
export * from "./RequirementSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports